<template>
    <a @click="accederCorreo(correo)" href="#" class="dropdown-item" v-for="correo in correos" :key="correo.id_correo">
        <div data-toggle="tooltip" data-placement="top" :title="correo.nombre_correo">
            <i class="fas fa-envelope-open-text ml-2 mr-1"></i> {{correo.nombre_correo}}
            <span v-if="correo.correo_usuario == '1'" class="badge bg-warning bg-blue float-right">{{ correo.n_nuevos}}</span>
            <span v-else class="badge bg-warning bg-yellow float-right">{{ correo.n_nuevos}}</span>
        </div>
    </a>
    <!---->
    <form id="formcorreos" method="post" :action="'https://' + direccionglobal" target="ifrm1">
        <iframe id="ifrm1" name="ifrm1" style="display:none"></iframe>
    </form>
</template>
<script>
import { ENTORNO_APUYEN } from '../../../../../../.env.js';
export default({
    props:{
        correos: Array
    },
    data() {
        return {
            url: ENTORNO_APUYEN.BaseURL,
            numero_correos_sin_leer : 0,
            isRendered: false,
            direccion:'',
        }   
    },
    watch: {
      
    },
    methods: {
        accederCorreo(correo) {
            document.getElementById('formcorreos').submit();
          
            const domain = localStorage.getItem('subdomain') + ".pwgs.app";

            window.open("https://" + domain + "/"+correo.href, "_target");
        },
 
  
    },
    mounted() {
        this.direccionglobal = localStorage.getItem('direccion');
    }
})
</script>